import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { getTicketDetails } from "../../api";
import "./CustomerDetails.css";

const TicketDetails = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { customerId, customerName, customerEmail, customerPhone } =
    location.state || {};
  const [customerDetails, setCustomerDetails] = useState([]);

  useEffect(() => {
    const fetchCustomerDetails = async () => {
      try {
        const response = await getTicketDetails(customerId);
        const data = response.data;
        setCustomerDetails(data || []);
      } catch (error) {
        console.error("Error fetching customer details:", error);
      }
    };

    fetchCustomerDetails();
  }, [customerId]);

  const handleBackClick = () => {
    navigate(-1);
  };

  const handleViewTicketClick = (ticket) => {
    navigate(`/admin/dashboard/detailed-ticket/${ticket.ticket_id}`, {
      state: { ticket, customerName, customerEmail, customerPhone },
    });
  };

  return (
    <div className="customer-details">
      <h2>Ticket Details</h2>
      <table className="details-table">
        <thead>
          <tr>
            <th>Customer Name</th>
            <th>Subject</th>
            <th>Ticket Details</th>
          </tr>
        </thead>
        <tbody>
          {customerDetails.length > 0 ? (
            customerDetails.map((ticket) => (
              <tr key={ticket.ticket_id}>
                <td>{customerName}</td>
                <td>{ticket.subject}</td>
                <td>
                  <button
                    className="view-ticket-button"
                    onClick={() => handleViewTicketClick(ticket)}
                  >
                    View Ticket Details
                  </button>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="3">No tickets found</td>
            </tr>
          )}
        </tbody>
      </table>
      <button className="back-button" onClick={handleBackClick}>
        Back
      </button>
    </div>
  );
};

export default TicketDetails;
